import React from 'react';
import classNames from 'classnames';
import './PhraseItem.less';

interface IPhraseItemProps extends React.ComponentProps<'button'> {}

const getClassName = (className?: string) => classNames('tt-phrase-item', className);

/**
 * Represents one of phrase part either Anchor or Verb.
 *
 * Copyright (c) 2020 Decisions All Rights Reserved
 */
export const PhraseItem = React.forwardRef(
  ({ className, type, ...otherProps }: IPhraseItemProps, ref: React.Ref<HTMLButtonElement>) => {
    return <button className={getClassName(className)} ref={ref} {...otherProps}></button>;
  }
);
